export const FocusFirstInputOnMount = {
  mounted() {
    const firstInput = document.querySelector(
      `#${this.el.id} input:not([type=hidden])`
    );

    if (firstInput != null) {
      firstInput.focus();
    }
  },
};
